import React from "react";
import {
  DesignImage,
  Testing,
  Deployment,
  Development,
  fullstack,
  htmlcss,
  fd1,
  fd2,
  fd3,
  Discovery,
} from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, FeatureGrid, Cta } from "../Common-component/ServiceKit";

const stacks = [
  {
    img: fd1,
    alt: "LAMP",
    title: "LAMP",
    text: "We use the customizable features of LAMP to create scalable applications that deliver excellent performance. Our custom solutions have successfully helped many brands in various industries over the years.",
  },
  {
    img: fd2,
    alt: "Framework Technologies",
    title: "Framework Technologies",
    text: "Our experienced team of developers is skilled in various framework technologies such as MEAN, PHP, and MERN. By partnering with us, you can expect exceptional web applications that meet your unique requirements.",
  },
  {
    img: fd3,
    alt: "Mobile Technologies",
    title: "Mobile Technologies",
    text: "Our experts have in depth knowledge of cutting edge mobile technologies like React, Swift, Ionic, Objective C, Java, and more. Hire our experienced professionals for cost-effective app development with quick turnaround times.",
  },
];

const process = [
  {
    img: Discovery,
    alt: "Discovery",
    title: "Discovery",
    text: "We gather information about your business needs and analyze them. We validate your idea or suggest a solution that meets your needs. We conduct thorough research, estimation, risk analysis, and requirement elicitation to find optimal solutions.",
  },
  {
    img: DesignImage,
    alt: "Design",
    title: "Design",
    text: "We aim to create an intuitive, flawless, and great user experience. We chalk out a UI/UX strategy, prepare software requirements, create wireframes, and build software architecture, user interface design, and prototypes. Prototypes are tested and validated with feedback at an early stage.",
  },
  {
    img: Development,
    alt: "Development",
    title: "Development",
    text: "Our experienced developers transform your ideas into digital reality with chosen languages, frameworks, technologies, and platforms. We build customized solutions following best coding practices and standards. We follow an agile approach to creating a continuous integration and delivery pipeline.",
  },
  {
    img: Testing,
    alt: "Testing",
    title: "Testing",
    text: "We rigorously test the system for inconsistencies, bugs, security, quality, performance, and errors. We use automated and manual tests to evaluate the functionalities and behaviour of the software under different scenarios and ensure that it matches your requirements and performs well on different devices and platforms.",
  },
  {
    img: Deployment,
    alt: "Deployment",
    title: "Deployment",
    text: "After thorough testing and performance checks, we deploy the system on preferred platforms or the cloud and integrate it with the necessary configurations. We ensure the environment and system are easy to manage and scale with less downtime. We continue monitoring the performance and fixing issues with comprehensive and continuous technical support.",
  },
];

const FullStackPage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="Full Stack"
      title="Full Stack Development Services For Streamlined Web Solutions"
      paragraphs={[
        "We offer comprehensive Full Stack Development services encompassing front-end, back-end, and database management. Our expert developers are skilled in cutting edge technologies like ReactJS, AngularJS, NodeJS, and MongoDB. With our Full Stack Development Services, you can expect a streamlined web solution that meets your business requirements.",
        "We take a collaborative approach to Full Stack Development, working closely with our clients to understand their specific needs and deliver customized solutions. Our developers ensure your website is optimized for performance, security, and scalability, giving you a competitive edge in the digital landscape. Partner with ATUM Information Technology for end-to-end Full Stack Development services that take your business to new heights.",
      ]}
      tags={["Front-End", "Back-End", "Database", "DevOps"]}
      img={fullstack}
      alt="Full stack development"
    />

    {/* CLIENT NEEDS */}
    <Section tint>
      <Intro
        chip="Client First"
        title="Understanding The Client's Needs"
        paragraphs={[
          "At ATUM Information Technology, we recognize that each client has unique requirements and objectives for their website or app, which is why we provide personalized full-stack development services. As a trustworthy development company based in Pune, we devote significant time to comprehending the client’s business, intended audience, and objectives before commencing any project.",
          "As a full-stack development agency, we engage in preliminary consultation sessions to explore the client’s website vision and gain insights into their industry, rivals, and target demographic. As part of our development process, we conduct a comprehensive evaluation of the client’s current status of the website or app, if available, to identify potential opportunities for growth and expansion.",
          "Once we understand the client’s needs and objectives clearly, we can suggest the most appropriate full-stack development services to address those requirements. As India’s leading full-stack development company, our skilled team offers a wide range of services, including:",
        ]}
      />
    </Section>

    {/* TECHNOLOGIES */}
    <Section>
      <Intro chip="What We Do" title="Technologies We Work With">
        <FeatureGrid items={stacks} cols={3} />
      </Intro>
    </Section>

    <Section>
      <Split
        img={htmlcss}
        alt="Web and front-end technologies"
        reverse
        chip="Front-End"
        title="Web & Front-End Technologies"
        paragraphs={[
          "We offer top notch full-stack development services supported by robust web and front-end technologies. Our vast resource pool of developers specializes in Meteor, Vue.js, React, Angular JS, HTML5, and more. Partner with us for outstanding web and front-end solutions.",
          "At ATUM Information Technology, we provide comprehensive Full-stack development services apart from the services mentioned above, including front-end and back-end development, database design, API integration, and DevOps. Our experienced developers deliver scalable, high performance solutions tailored to our client’s unique business needs.",
          "Our full-stack web development services in India offer comprehensive custom solutions with the help of our expert full-stack developers. We build high performing web and mobile applications that provide a competitive advantage to your business across various industries.",
        ]}
      />
    </Section>

    {/* PROCESS */}
    <Section tint style={{ paddingBottom: 30 }}>
      <Intro
        chip="How We Work"
        title="Full-Stack Development Process"
        paragraphs={[
          "Full-stack development involves creating a completely digital system from start to finish. Here are the steps we take to ensure a successful project:",
        ]}
      />
    </Section>
    {process.map((p, i) => (
      <Section key={p.title}>
        <Split
          img={p.img}
          alt={p.alt}
          reverse={i % 2 === 1}
          chip={"Step " + (i + 1)}
          title={p.title}
          paragraphs={[p.text]}
        />
      </Section>
    ))}

    {/* HIRE */}
    <Cta
      chip="Hire Us"
      title="Hire Our Full-Stack Developers From ATUM Information Technology"
      paragraphs={[
        "At ATUM Information Technology, you can hire our full-stack developers who provide personalized front-end and back-end development services. During creation, we constantly communicate with our clients to ensure that their website or app meets their expectations and fulfils their business goals.",
        "Our team is proficient in various technologies and tools, such as ReactJS, AngularJS, NodeJS, MongoDB, and more, and we create responsive, visually appealing, and user friendly applications using these technologies. Contact our full-stack development company in Pune today to avail the services of a reliable full-stack development company in India for your business’s full-stack projects.",
      ]}
    />
  </ServiceShell>
);

export default FullStackPage;